import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FileTypeService {

  constructor() { }

  FILE_MIME_TYPES = [
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/pdf",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "video/mp4",
    "video/webm",
    "video/x-msvideo",
    "audio/mpeg",
    "audio/wav",
    "image/avif",
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/webp"
  ];

  VIDEO_AUDIO_SUPPORTED_TYPE = [
    "video/mp4",
    "video/webm",
    "video/x-msvideo",
    "audio/mpeg",
    "audio/wav"
  ];

  THUMBNAIL_MIME_TYPES = [
    "image/jpeg",
    "image/png"
  ];

  IMAGE_MIME_TYPES = [
    "image/jpeg",
    "image/png",
    "image/svg+xml"
  ];

  getIconByType(type: string, size: 'small' | 'large') {
    /*
    Unsupported: kb_unsupported.svg | kb_unsupported_large.svg
    Document: kb_document.svg | kb_document_large.svg
    Video: kb_video.svg | kb_video_large.svg
    Audio: kb_audio.svg | kb_audio_large.svg
    Image: kb_image.svg | kb_image_large.svg
    */
    let icon: string = (size === 'small') ? "kb_unsupported.svg" : "kb_unsupported_large.svg";
    switch (type?.toLowerCase()) {
      case 'doc':
      case 'docx':
      case 'pdf':
      case 'ppt':
      case 'pptx':
      case 'xls':
      case 'xlsx':
        icon = (size === 'small') ? "kb_document.svg" : "kb_document_large.svg";
        break;
      case 'mp4':
      case 'webm':
      case 'avi':
        icon = (size === 'small') ? "kb_video.svg" : "kb_video_large.svg";
        break;
      case 'mp3':
      case 'wav':
        icon = (size === 'small') ? "kb_audio.svg" : "kb_audio_large.svg";
        break;
      case 'apng':
      case 'avif':
      case 'gif':
      case 'jpeg':
      case 'jpg':
      case 'png':
      case 'webp':
        icon = (size === 'small') ? "kb_image.svg" : "kb_image_large.svg";
        break;
    }
    return icon;
  }

  getLabelByType(type: string) {
    let label: string = "Unsupported";

    // Labels: Document, Video, Audio, Image
    switch (type?.toLowerCase()) {
      case 'doc':
      case 'docx':
      case 'pdf':
      case 'ppt':
      case 'pptx':
      case 'xls':
      case 'xlsx':
        label = "Document";
        break;
      case 'mp4':
      case 'webm':
      case 'avi':
        label = "Video";
        break;
      case 'mp3':
      case 'wav':
        label = "Audio";
        break;
      case 'apng':
      case 'avif':
      case 'gif':
      case 'jpeg':
      case 'jpg':
      case 'png':
      case 'webp':
        label = "Image";
        break;
    }
    return label;
  }

  getFileExtensionFromUrl(url: string) {
    let extension = '';
    if (url) {
      extension = url.substring(url.lastIndexOf(".") + 1).split("?")[0];
    }
    return extension;
  }
}
